import { render, staticRenderFns } from "./SelectEditor.vue?vue&type=template&id=22ad8b24"
import script from "./SelectEditor.vue?vue&type=script&lang=js"
export * from "./SelectEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports